export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy'
export const DEFAULT_HOUR_FORMAT = 'H:mm'

export const API_DATE_FORMAT = 'yyyy-MM-dd'
